const BACKEND_AMOUNT_MODIFIER = 10000;

export default BACKEND_AMOUNT_MODIFIER;
